import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_LOCK_EXPOSURE_ACTION_TYPE = createNamedActions(
  'commandCenterLockExposure',
  {
    SET_LOCK_EXPOSURE: 'SET_LOCK_EXPOSURE',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterLockExposureAction = catchAsyncActionError(() => async dispatch => {
  try {
    const data = await fetchSafe(() =>
      commandCenterLoansApi.getLockExposure({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    dispatch({
      type: COMMAND_CENTER_LOCK_EXPOSURE_ACTION_TYPE.SET_LOCK_EXPOSURE,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403
    // degrades to null — otherwise the zone skeleton never clears.
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.LOCK_EXPOSURE));
  }
});
